import { render, staticRenderFns } from "./childDomainCert.vue?vue&type=template&id=f88ac8ba&scoped=true&"
import script from "./childDomainCert.vue?vue&type=script&lang=js&"
export * from "./childDomainCert.vue?vue&type=script&lang=js&"
import style0 from "./childDomainCert.vue?vue&type=style&index=0&id=f88ac8ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88ac8ba",
  null
  
)

export default component.exports